jQuery(document).ready(function(){

	// Menu
	jQuery("#menu, .openMenuBG").bind('click', function() {
		if(jQuery('body').hasClass('openMenu')){
			jQuery('body').removeClass('openMenu');
		} else {
			jQuery('body').addClass('openMenu');
			jQuery('body').removeClass('openSearch');
		}
		return false
	});	
	
	// Search Bar
  jQuery(".search-btn, header .closeSearch").bind('click', function() {
		if(jQuery('body').hasClass('openSearch')){
			jQuery('body').removeClass('openSearch');
			jQuery('#search input[type=search]').blur();			
		} else {
			jQuery('body').addClass('openSearch');
			jQuery('body').removeClass('openMenu');
			jQuery('#search input[type=search]').focus();
		}
		return false
	});	

});

// Cookie Functionality
function getAllUrlParams(url) {
  var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
  var obj = {};

  if (queryString) {
    queryString = queryString.split('#')[0];
    var arr = queryString.split('&');

    for (var i = 0; i < arr.length; i++) {
      var a = arr[i].split('=');
      var paramName = a[0];
      var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

      paramName = paramName.toLowerCase();
      if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

      if (paramName.match(/\[(\d+)?\]$/)) {

        var key = paramName.replace(/\[(\d+)?\]/, '');
        if (!obj[key]) obj[key] = [];

        if (paramName.match(/\[\d+\]$/)) {
          var index = /\[(\d+)\]/.exec(paramName)[1];
          obj[key][index] = paramValue;
        } else {
          obj[key].push(paramValue);
        }
      } else {
        if (!obj[paramName]) {
          obj[paramName] = paramValue;
        } else if (obj[paramName] && typeof obj[paramName] === 'string'){
          obj[paramName] = [obj[paramName]];
          obj[paramName].push(paramValue);
        } else {
          obj[paramName].push(paramValue);
        }
      }
    }
  }
  return obj;
}

const fbclid = getAllUrlParams().fbclid ? 'fbclid='+getAllUrlParams().fbclid : '';
const gclid = getAllUrlParams().gclid ? 'gclid='+getAllUrlParams().gclid : ''

if(fbclid || gclid ) {
	const allURLParams = JSON.stringify(getAllUrlParams());
	setCookie('gg_ads', allURLParams, 2)
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(name) {
  var result = document.cookie.match(new RegExp(name + '=([^;]+)'));
  result && (result = JSON.parse(result[1]));
  return result;
}
    
jQuery(window).load(function() {
  if (getCookie("gg_ads")) {
    var ggAds = getCookie("gg_ads");

    // Check and set fbclid
    if (ggAds.fbclid) {
      var fbclidInput = document.getElementById('fbclid_input');
      if (fbclidInput) { // Check if fbclidInput exists
        fbclidInput.value = ggAds.fbclid;
        console.log("fbclid set to:", fbclidInput.value);
      } else {
        console.warn("fbclid_input element not found on the page.");
      }
    }

    // Check and set gclid
    if (ggAds.gclid) {
      var gclidInput = document.getElementById('gclid_input');
      if (gclidInput) { // Check if gclidInput exists
        gclidInput.value = ggAds.gclid;
        console.log("gclid set to:", gclidInput.value);
      } else {
        console.warn("gclid_input element not found on the page.");
      }
    }
  } else {
    console.warn("gg_ads cookie not found.");
  }
});


function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '')
  }
  let value = ''
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  const formatString = format || this.money_format

  function defaultOption(opt, def) {
    return typeof opt === 'undefined' ? def : opt
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2)
    thousands = defaultOption(thousands, ',')
    decimal = defaultOption(decimal, '.')

    if (isNaN(number) || number == null) {
      return 0
    }
    number = (number / 100.0).toFixed(precision)
    const parts = number.split('.')
    const dollars = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    )
    const cents = parts[1] ? decimal + parts[1] : ''

    return dollars + cents
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2)
      break
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0)
      break
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',')
      break
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',')
      break
    default:
      value = formatWithDelimiters(cents, 2)
      break
  }

  return formatString.replace(placeholderRegex, value)
}
